<template>
  <header class="header px-xl-4 px-xxl-5" :class="{'js-collapse': isOpen, 'bg-f': bgClass != ''}">
    <div class="container-fluid px-3">
      <div class="navbar-header-end" style="padding-right: 20px;">
        <!-- 语言切换按钮 -->
        <div class="language-switcher d-none d-lg-flex align-items-center mr-3">
          <button 
            type="button"
            class="btn btn-sm lang-btn"
            :class="{'active': $i18n.locale === 'en'}"
            :style="{ 'color': langBtnColor }"
            @click="changeLang('en')"
            title="English">
            English
          </button>
          <span class="lang-divider" :style="{ 'color': langBtnColor }">/</span>
          <button 
            type="button"
            class="btn btn-sm lang-btn"
            :class="{'active': $i18n.locale === 'zh-TW'}"
            :style="{ 'color': langBtnColor }"
            @click="changeLang('zh-TW')"
            title="繁體中文">
            繁體中文
          </button>
        </div>
        
      </div>
      <div class="row">
        <div class="col-12">
          <nav class="navbar navbar-expand-lg">
            <div class="navbar-header">
              <a href="#" class="logo" aria-label="IASE Certifications">
                <img width="280" height="84" class="img-fluid entered lazyloaded"
                  :src="logo">
              </a>
              <button 
                type="button" 
                class="navbar-toggler"
                @click="isOpen = !isOpen"
                :class="{'collapsed': !isOpen, 'active': isOpen}">
                <span class="icon-bar" :class="{'bg-0': bgClass != ''}"></span>
                <span class="icon-bar" :class="{'bg-0': bgClass != ''}"></span>
                <span class="icon-bar" :class="{'bg-0': bgClass != ''}"></span>
              </button>
            </div>

            <div class="collapse navbar-collapse" id="navbarNav">
              <ul id="menu-menu-principal-en" class="navbar-nav">
                <li
                  class="menu-item menu-item-type-post_type menu-item-object-page dropdown"
                  v-for="(item, index) in routes"
                  :key="index"
                  :class="{'active': $router.currentRoute.name == item.name}"
                  v-show="!item.notShow"
                  @click="changeOpen(item)">
                  <a v-if="item.type == 'link'" :class="{'dropdown-toggle': item.children, 'show': item.showMenu, 'li-color-black': liClass != ''}" href="https://iase-registration.esg-certifications.com/login">{{ typeof item.title === 'function' ? item.title() : item.title }}</a>
                  <router-link :to="item.children ? '' : item.path" :class="{'dropdown-toggle': item.children, 'show': item.showMenu, 'li-color-black': liClass != ''}" v-if="!item.notShow && item.type != 'link'">{{ typeof item.title === 'function' ? item.title() : item.title }}</router-link>
                  <div class="mask" v-show="item.showMenu" @click.stop="changeOpen({}, 'closeMenu')"></div>
                  <ul v-if="item.children" class=" dropdown-menu dropdown-menu-center dropdown-multi" :class="{'show': item.showMenu}" style="z-index: 991;">
                    <li
                      class="menu-item menu-item-type-post_type menu-item-object-page"
                      v-for="(item2, index2) in item.children"
                      :key="index2"
                      :class="{'menu-cert': item2.type == 'page'}">
                      <router-link
                        :to="item2.path"
                        class="dropdown-item"
                        :class="{'dropdown-toggle': item2.type == 'title', 'li-color-black': liClass != ''}"
                      >
                        {{ typeof item2.title === 'function' ? item2.title() : item2.title }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
              <div class="d-lg-none mt-3">
                <div class="box-social-network mod-sm">
                  <a href="https://www.linkedin.com/company/iase-certifications/" target="_blank" rel="noopener"
                    class="item" aria-label="Redes Sociais">
                    <i class="fa-classic lab la-linkedin-in"></i>
                  </a>
                </div>
                
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="navbar-collapse collapse" :class="{ 'show': isOpen }" id="navbarNav" @click="changeOpen({}, 'closeMenu')" style="">
      <!-- 移动端语言切换 -->
      <div class="language-switcher-mobile">
        <button 
          type="button"
          class="btn lang-btn"
          :class="{'active': $i18n.locale === 'en'}"
          @click="changeLang('en')">
          English
        </button>
        <span class="lang-divider">/</span>
        <button 
          type="button"
          class="btn lang-btn"
          :class="{'active': $i18n.locale === 'zh-TW'}"
          @click="changeLang('zh-TW')">
          繁體中文
        </button>
        
      </div>
      <ul id="menu-menu-principal-en" class="navbar-nav">
        <li
          class="menu-item menu-item-type-post_type menu-item-object-page dropdown"
          v-for="(item, index) in routes"
          :key="index"
          :class="{'active': $router.currentRoute.name == item.name, 'li-color-black': liClass != ''}"
          @click.stop="changeOpen(item, 'closeMenu')">
          <a v-if="item.type == 'link'" :class="{'dropdown-toggle': item.children, 'show': item.showMenu}" href="https://iase-registration.esg-certifications.com/login">{{ typeof item.title === 'function' ? item.title() : item.title }}</a>
          <router-link v-else :to="item.children ? '' : item.path" :class="{'dropdown-toggle': item.children, 'show': item.showMenu}">{{ typeof item.title === 'function' ? item.title() : item.title }}</router-link>
          <ul v-if="item.children" class=" dropdown-menu dropdown-menu-center dropdown-multi" :class="{'show': item.showMenu}">
            <li
              class="menu-item menu-item-type-post_type menu-item-object-page"
              v-for="(item2, index2) in item.children"
              :key="index2"
              @click.stop="changeOpen(item2, 'closeMenu')"
              :class="{'menu-cert': item2.type == 'page', 'li-color-black': liClass != ''}">
              <router-link
                :to="item2.path"
                class="dropdown-item"
                :class="{'dropdown-toggle': item2.type == 'title'}"
              >
                {{ typeof item2.title === 'function' ? item2.title() : item2.title }}
              </router-link>
              
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
export default {
  name: 'headerComponent',
  data() {
    return {
      activeIndex2: '1',
      routes: [],
      isOpen: false,
      bgClass: '',
      liClass: '',
      logo: require('@/assets/home/header-logo.png'),
      langBtnColor: '#fff'
    }
  },
  created() {
    this.routes = this.$router.options.routes.filter(item => !item.hide)
    console.log(this.routes)
    window.addEventListener('scroll', this.scrollFn, { passive: true })
    // 监听触摸移动（辅助：实时获取滚动）
    window.addEventListener('touchmove', this.scrollFn, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollFn);
    window.removeEventListener('touchmove', this.scrollFn);
  },
  methods: {
    // 切换语言
    // this.$i18n.locale = 'zh-TW' // 切换到繁体中文
    // this.$i18n.locale = 'en'  
    changeLang(lang) {
      console.log(lang)
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
      this.$router.push(this.switchLocalePath(lang))
    },
    scrollFn() { 
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop > 10) {
        this.bgClass = 'bg-f'
        this.liClass = 'li-color-black'
        this.langBtnColor = '#000'
        this.logo = require('@/assets/home/header-logo2.png')
      } else {
        this.bgClass = ''
        this.liClass = ''
        this.langBtnColor = '#fff'
        this.logo = require('@/assets/home/header-logo.png')
      }
    },
    changeOpen(item) {
      console.log(item, this.$router)
      if (!item) {
        this.routes.map(item2 => {
          item2.showMenu = false
        })
      } else {
        this.routes.map(item2 => {
          if (item2.title== item.title) {
            item.showMenu = !item.showMenu
          } else {
            item2.showMenu = false
          }
        })
      }
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-menu.el-menu--horizontal {
    border: none !important;

    li {
      border: none;
      font-size: 20px;
    }
  }

  .el-divider--vertical {
    height: 2em;
  }

  .el-menu-item:hover {
    background-color: rgba(0, 0, 0, 0) !important;
    color: #F5BA2F !important;
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 800;
  left: 0;
  top: 0;
}
.li-color-black {
  color: black !important;
}
.active a{
  color: #F5BA2F !important;
}

.navbar-header-end {
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 99999;
}
/* 语言切换按钮样式 */
.language-switcher {
  
  .lang-btn {
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;
    border: none;
    background: transparent;
    box-shadow: none;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      opacity: 1;
      color: #F5BA2F;
    }
    
    &.active {
      opacity: 1;
      color: #F5BA2F !important;
      font-weight: 600;
    }
  }
  
  .lang-divider {
    color: inherit;
  }
}

/* 移动端语言切换器 */
@media (max-width: 991px) {
  .language-switcher-mobile {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
    
    
    .lang-btn {
      font-size: 16px;
      background: transparent;
      box-shadow: none;
      border: none;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s ease;
      width: auto;
      font-size: 22px;
      &:hover,
      &.active {
        color: #F5BA2F;
      }
    }
    
    .lang-divider {
      color: #fff;
    }
  }
}
</style>